export enum actionTypes {
    UPDATE_DEVICE = 'UPDATE_DEVICE'
}

export const SUPPORTED_BROWSER_NAMES = ['safari', 'chrome', 'edge', 'firefox'];
export const SUPPORTED_OS = ['ios', 'android', 'windows', 'macintosh'];
